import { render } from "./CoachInfoBox.vue?vue&type=template&id=2c334843&scoped=true&ts=true"
import script from "./CoachInfoBox.vue?vue&type=script&lang=ts"
export * from "./CoachInfoBox.vue?vue&type=script&lang=ts"

import "./CoachInfoBox.vue?vue&type=style&index=0&id=2c334843&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c334843"]])

export default __exports__